import React from 'react';
import cn from 'classnames';
import endpoints from '../../define/endpoints';
import { useAuth0 } from '../../context/auth0';

// app_main_wpml is the wp_localize_script global (functions.php); read directly like the other modals, despite the lint errors.
const PROVIDERS = [
  {
    connection: 'google-oauth2',
    icon: 'logo-google-g',
    label: app_main_wpml.continue_with_google,
  },
  {
    connection: 'apple',
    icon: 'logo-apple',
    label: app_main_wpml.continue_with_apple,
  },
  {
    connection: 'facebook',
    icon: 'logo-facebook-f',
    label: app_main_wpml.continue_with_facebook,
  },
];

// Full-width provider pills that go straight to the chosen Auth0 connection.
const SocialLoginButtons = () => {
  const { loginWithConnection } = useAuth0();

  return (
    <div className="login">
      {PROVIDERS.map(({ connection, icon, label }) => (
        <button
          key={connection}
          type="button"
          onClick={() => loginWithConnection(connection)}
          className={cn('btn', 'login__btn')}
        >
          <img src={`${endpoints.bucket}icons/${icon}.svg`} alt="" />
          {label}
        </button>
      ))}
    </div>
  );
};

export default SocialLoginButtons;
